import React from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';

import { usePickTypesEducation } from '@/feature/educational-picks/components/PickTypesEducationModalProvider';
import { ProjectionIcon } from '@/feature/lobby/components/ProjectionIcon';
import { checkIfBoostedProjection, checkIfEdgeProjection } from '@/feature/lobby/utils/lineupsUtils';
import { Projection, ProjectionType } from '@/types/api.generated';
import { AtLeast } from '@/types/utils';

type SingleProjectionIconProps = {
    selectedProjection: AtLeast<Projection, 'type'>;
    style?: StyleProp<ViewStyle>;
    showLevels?: boolean;
    isVoided?: boolean;
    triggerEducationalSheet?: boolean;
};

/* Display the projection icon for selected projection, with optional education sheet trigger */
export const SingleProjectionIcon = ({
    selectedProjection,
    style,
    showLevels = true,
    isVoided = false,
    triggerEducationalSheet = false,
}: SingleProjectionIconProps) => {
    const isNonRegularProjection = selectedProjection.type !== ProjectionType.Regular;
    const shouldShowLevelsForProjection =
        (checkIfBoostedProjection(selectedProjection.type) || checkIfEdgeProjection(selectedProjection.type)) &&
        showLevels;

    const { showPickTypesEducationModal } = usePickTypesEducation();

    const onPress = () => {
        showPickTypesEducationModal({
            projectionType: selectedProjection.type,
            specialIncreased: (selectedProjection.nonRegularPercentage ?? 0) > 0,
        });
    };

    if (!isNonRegularProjection) {
        return null;
    }

    return (
        <TouchableOpacity
            onPress={triggerEducationalSheet ? onPress : undefined}
            disabled={!triggerEducationalSheet}
            style={styles.tapTargetStyle}
            activeOpacity={1}
            hitSlop={{
                top: 12,
                bottom: 12,
                left: shouldShowLevelsForProjection ? 6 : 12,
                right: shouldShowLevelsForProjection ? 7 : 12,
            }}
        >
            <ProjectionIcon
                selectedProjection={selectedProjection}
                style={style}
                showLevels={showLevels}
                isVoided={isVoided}
            />
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    tapTargetStyle: {
        zIndex: 10,
    },
});
